const subordinateRoutes = [
  {
    path: '/subordinate/management',
    name: 'subordinate-management',
    component: () => import('@/views/subordinate/subordinate-management'),
    meta: {
      needLogin: true
    }
  }
]

export default subordinateRoutes
